import angular from 'angular';
import EnvironmentProvider from './EnvironmentProvider';

const providersModule = angular.module('tinaba.framework.providers', [
    EnvironmentProvider.name
]);

export default providersModule;


/** WEBPACK FOOTER **
 ** ./client/app/common/services/tinaba-framework/providers.js
 **/